
function CCTSearch(placeholderCurrent = 'Recherchez un lieu ou un restaurant...', type_search='carte_cadeau') {
    this.searchClient = algoliasearch('BKOWC37603', '8fc576812f9182106f19995631767c72');
    this.placeholderCurrent = placeholderCurrent
    this.type_search = type_search
    this.init();
}

CCTSearch.prototype = {
    _:{
        selectors:{
        },
        messages: { }
    },
    emit:function(name){
        var colorBG = "#1e98ec"
        console.log("%c→ EMIT CCTSearch." + name,"background:"+colorBG+";color:#FFF")
        console.log({arguments})
        $(document).trigger('CCTSearch.'+name,arguments);
    },
    delay: async function(ms){
        return new Promise(resolve => setTimeout(resolve, ms))
    },
    
    templateSearch(type,hit){
        switch (type){
            case 'city':
            return `<p><a target="_blank" href="${hit.url}">${hit.name}</a><p>${hit.region}</p></p>`
            break;
        }
    },
    html_search:function(){
        //hidden
        let template_result = `
        <div class="ais-modal hidden">
            <div class='ais-shadow js-close_search'></div>
            <div class="ais-InstantSearch ">
                    <div class="searchbox">
                        <div class="ais-SearchBox-retour js-close_search"></div>
                        <div id="searchbox"></div>
                    </div>
                    <div id="searchresult" class="search_empty">
                        <div class="ais-hits-title js-title-hits-city hidden" >Villes</div>
                        <div id="cities-hits" class="ais-hits "></div>
                        <div class="ais-hits-title js-title-hits-restaurant hidden" >Restaurants</div>
                        <div id="restaurants-hits" class="ais-hits" ></div>
                        <div class="ais-hits-title js-title-hits-region hidden" >Regions</div>
                        <div id="regions-hits" class="ais-hits" ></div>
                    </div>
           </div>
    </div>
    `;
        $("body").append(template_result)
    },
    instance_agolia:  function(){
        // console.log({searchClient:this.searchClient , algoliasearch : typeof algoliasearch})
        if( typeof algoliasearch ==='function' && $("#searchbox").length > 0){
            const self = this;
            
            this.search = instantsearch({
                indexName: 'regions_index',
                searchClient:this.searchClient
            });
            
            // Ajout du widget SearchBox pour la barre de recherche
            let searchBox = instantsearch.widgets.searchBox(
                {
                    container: '#searchbox',
                    placeholder:  this.placeholderCurrent
                })
                this.search.addWidgets([searchBox]);
                
                // Ajout des résultats pour l'index des villes
                let option_city = {
                    container: '#cities-hits',
                    escapeHTML:true,
                    transformItems(items, { results }) {
                        
                        if (results.query === ''){
                            $('.js-title-hits-city').addClass("hidden");
                            $("#searchresult").addClass("search_empty")
                            return []
                        };
                        if(items.length > 0){
                            $('.js-title-hits-city').removeClass("hidden");
                        }else{
                            $('.js-title-hits-city').addClass("hidden");
                        }
                        /*
                        if(self.type_search ==="cours_de_cuisine"){ 
                        //  items = items.filter(el=> !!el.validated_cc && el.status_cc == "ACTIVE" )
                        items = items.filter(el=> el.status_cc == "ACTIVE")
                        }else{
                        items = items.filter(el=> !!el.status)
                        }
                        */
                        items = items.filter(el=> !!el.status)
                        return items;
                    },
                    templates: {
                        item(hit, { html, components }){
                            let url_page = hit.url
                            let validated_cc = hit.validated_cc
                            
                            if(self.type_search ==="privatisation" && hit.url_privatisation !=''  && !!validated_privatisation){ 
                                url_page = hit.url_privatisation
                            }else if(self.type_search ==="cours_de_cuisine" && hit.url_cc !=''  && !!validated_cc){ 
                                url_page = hit.url_cc
                            }else{ 
                                url_page = hit.url
                            }
                            
                            return html`<a  href="${url_page}">
                            <p style="font-weight: 400;">${hit.name}</p>
                            <p style="font-size: 13px;">${hit.region}</p>
                        </a>`;
                        },
                        empty: ({ query }, { html }) =>
                        html`<div></div>`
                    }
                }
                this.search.addWidgets([
                    instantsearch.widgets.index({
                        indexName: 'cities_index' })
                        .addWidgets([instantsearch.widgets.hits(option_city)])
                    ]);
                    // this.search.addWidgets([instantsearch.widgets.hits(option_city)]);
                    
                    
                    let option_restaurant = {
                        container: '#restaurants-hits',
                        hitsPerPage: 10,
                        escapeHTML: true,
                        transformItems(items, { results }) {
                            if (results.query === ''){
                                $('.js-title-hits-restaurant').addClass("hidden");
                                $("#searchresult").addClass("search_empty")
                                return []
                            };
                            if(items.length > 0){
                                $('.js-title-hits-restaurant').removeClass("hidden");
                            }else{
                                $('.js-title-hits-restaurant').addClass("hidden");
                            }
                            /*
                            if(self.type_search ==="cours_de_cuisine"){ 
                            //  items = items.filter(el=> !!el.validated_cc && !!el.offre_cours_de_cuisine)
                            items = items.filter(el=> !!el.validated && !!el.offre_cours_de_cuisine)
                            }else if(self.type_search ==="carte_cadeau"){ 
                            items = items.filter(el=> !!el.validated && !!el.offre_carte_cadeau)
                            }else{
                            items = items.filter(el=> !!el.validated)
                            }
                            */
                            items = items.filter(el=> !!el.validated)
                            
                            items = items.filter(el=> !!el.status)
                            items = items.map(item => ({
                                ...item,
                                count_dist: item.distinctions.reduce((acc,dist)=>acc+dist.count,0)
                            }));
                            return items;
                        },
                        templates: {
                            item(hit, { html, components }) {
                                let url_page = hit.url
                                let validated_cc = hit.validated_cc
                                let validated_privatisation = hit.validated_privatisation

                                if(self.type_search ==="privatisation" && hit.url_privatisation !=''  && !!validated_privatisation){ 
                                    url_page = hit.url_privatisation
                                }else if(self.type_search ==="cours_de_cuisine" && hit.url_cc !=''  && !!validated_cc){ 
                                    url_page = hit.url_cc
                                }else{ 
                                    url_page = hit.url
                                }
                                
                                return html`<a  href="${url_page}">
                            <p style="display: flex;font-size: 14px;font-weight: 400;">
                                ${hit.count_dist > 0  ? html`<div class="restaurant_distinctions" style="display: flex;margin-right:5px;align-items: center;z-index: 1;">
                                    ${hit.distinctions.map(distinction =>{
                                switch (distinction.count) {
                                    case 1:
                                    return html`<div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >`
                                    break;
                                    case 2:
                                    return html`<div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >
                                                    <div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >`
                                    break;
                                    case 3:
                                    return html`<div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >
                                                <div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >
                                                <div class="distinction_icon" alt="${distinction.name}" style="width: 17px;height: 17px;background-image:url(${distinction.icon});background-size: contain;background-repeat: no-repeat;    z-index: -1;"></div >`
                                    break;
                                }
                            })}
                                </div >` : html`` }  ${hit.name} </p>
                            <p style="font-size: 13px;">${hit.city} </p>
                        </a>`;
                        },
                        empty: ({ query }, { html }) =>
                        html`<div></div>`
                    }
                }
                
                // Ajout des résultats pour l'index des restaurants
                this.search.addWidgets([
                    instantsearch.widgets.index({
                        indexName: 'restaurants_index' })
                        .addWidgets([instantsearch.widgets.hits(option_restaurant)])
                    ]);
                    
                    
                    let option_region = {
                        escapeHTML:false,
                        container: '#regions-hits',
                        transformItems(items, { results }) {
                            if (results.query === ''){
                                $('.js-title-hits-region').addClass("hidden");
                                $("#searchresult").addClass("search_empty")
                                return []
                            };
                            
                            if(items.length > 0){
                                $('.js-title-hits-region').removeClass("hidden");
                            }else{
                                $('.js-title-hits-region').addClass("hidden");
                            }
                            
                            if($('.js-title-hits-city.hidden').length > 0 &&
                            $('.js-title-hits-restaurant.hidden').length > 0 &&
                            $('.js-title-hits-region.hidden').length > 0 ){
                                $("#searchresult").addClass("search_empty")
                            }else{
                                $("#searchresult").removeClass("search_empty")
                            }
                            /*
                            //items = items.filter(el=> !!el.status)
                            if(self.type_search ==="cours_de_cuisine"){ 
                            //  items = items.filter(el=> !!el.validated_cc && el.status_cc == "ACTIVE" )
                            items = items.filter(el=> el.status_cc == "ACTIVE")
                            }else{
                            items = items.filter(el=> !!el.status)
                            }
                            */
                            items = items.filter(el=> !!el.status)
                            return items;
                        },
                        templates: {
                            item(hit, { html, components }) {
                                let url_page = hit.url
                                let validated_cc = hit.validated_cc
                                let validated_privatisation = hit.validated_privatisation
                                if(self.type_search ==="privatisation" && hit.url_privatisation !=''  && !!validated_privatisation){ 
                                    url_page = hit.url_privatisation
                                }else if(self.type_search ==="cours_de_cuisine" && hit.url_cc !='' && !!validated_cc){ 
                                    url_page = hit.url_cc
                                }else{ 
                                    url_page = hit.url
                                }
                                return html`<a  href="${url_page}">
                            <p>${hit.name} </p>
                        </a>`;
                            },
                            empty: ({ query }, { html }) =>
                            html`<div></div>`
                        }
                    }
                    this.search.addWidgets([instantsearch.widgets.index({indexName: 'regions_index'})
                    .addWidgets([instantsearch.widgets.hits(option_region)])]);
                    
                    this.search.start();
                    
                    //  this.search.dispose();
                }else{
                    console.error( "algoliasearch n'est pas installé")
                }
                return true
            },
            toggle_search:function(){
                if($('.ais-modal').hasClass('hidden')){
                    $('.ais-modal').removeClass('hidden')
                    $('.ais-InstantSearch').scrollTop(0);
                    $('.ais-SearchBox-input').focus();
                    
                }else{
                    $('.ais-modal').addClass('hidden')
                }
            },
            generateDistinction:function(distinctions){
                // console.log({distinctions})
                return 'star star'
            },
            init:async function () {
                this.DEBUGLOG = false
                console.log("%cSTART CCT.search", "background:cyan;color:#333")
                //  $("#MainContent").css("margin-top",$("header").height())
                this.bindEvents();
                this.html_search();
                this.instance_agolia();
                await this.delay(300)
                //$("#MainContent").css("margin-top",$("header").height())
            },
            bindEvents:function(){
                $("body")
                .off("click.open_search").on("click.open_search", ".js-open_search",_.bind(this.toggle_search, this))
                .off("click.close_search").on("click.close_search", ".js-close_search",_.bind(this.toggle_search, this))
                //    .off("keyup.input_search").on("keyup.input_search", ".ais-SearchBox-input",_.bind(this.input_search, this))
                /*
                $("body")
                .off("change.button_sort").on("change.button_sort", ".js-button-sort",_.bind(this.selectSortBy, this))
                .off("click.product_paginate").on("click.product_paginate", ".js-restaurant_paginate a",_.bind(this.clickProductPaginate, this))
                .off("click.filter_tag").on("click.filter_tag", ".js-filter_tag",_.bind(this.checkboxFilterTags, this))
                .off("click.button-more").on("click.button-more", ".js-button-more",_.bind(this.displayOtherProducts, this))
                .off("change.select-product").on("change.select-product", ".js-select-product",_.bind(this.changeSelectVariants, this))
                .off("click.add_product_cart").on("click.add_product_cart", ".js-add_product",_.bind(this.addproductCart, this))
                .off("click.open_filtre").on("click.open_filtre", ".js-btn-filtre-open",_.bind(this.openFilterMobile, this))
                .off("click.close_filtre").on("click.close_filtre", ".js-btn-filtre-close",_.bind(this.closeFilterMobile, this))
                
                $(document)
                .on('TT.filtersValidated', _.bind(this.render, this))
                .on('TT.clearCart',_.debounce( _.bind(this.render, this), TT._.debounceTimeValue))
                .on('TT.removeTTProducts',_.debounce( _.bind(this.removeTTProducts, this), TT._.debounceTimeValue))
                .on('TT.itemCartUpdated', _.bind(this.synchronizeProductsDisplay, this))
                .on('TT.refreshQty', _.bind(this.synchronizeProductsDisplay, this))
                .on('TT.openBtnQty',_.bind(this.openBtnQty,this))
                */
            }
        }
        
